module.exports = __webpack_public_path__ + "img/image14.2ab93875.jpg";